// Morphology and Rhythm Statement generator

export const MorphologyLabels = [
    'rbbb',
    'lbbb',
    'other_intraventricular_blocks',
    'lvh',
    'rvh',
    'rae',
    'lae',
    'anterior_old_mi',
    'inferior_old_mi',
    'lateral_old_mi',
    'septal_old_mi',
    'anterior_acute_mi',
    'inferior_acute_mi',
    'lateral_acute_mi',
    'septal_acute_mi',
    'anterior_ischemia',
    'inferior_ischemia',
    'lateral_ischemia',
    'septal_ischemia',
    'acute_pericarditis',
    'early_repolarization',
    'prolonged_qt',
    'paced_ecg',
    'wpw',
    'normal_and_otherwise_normal',
    'left_axis_deviation',
    'right_axis_deviation'
]

export const RhythmLabels = [
    'normal_sinus_rhythm',
    'sinus_rhythm',
    'atrial_fibrillation',
    'atrial_flutter',
    '1st_degree_av_block',
    '2nd_degree_av_block_mobiz_1',
    '2nd_degree_av_block_mobiz_2',
    '3rd_degree_av_block',
    'wide_qrs_tachy',
    'sinus_arrythmia',
    'marked_sinus_arrythmia',
    'paced_rhythm',
    'marked_bradycardia',
    'junctional_rhythm',
    'ectopic_atrial_rhythm',
    'spv_tachy',
    'undetermined_rhythm',
    'sinus_tachy',
    'bigeminy',
    'pvcs',
    'pac',
    'sinus_pause',
    'short_pr',
    'atrial_bigeminy',
    'ventricular_bigeminy'
]

const main = (input) => {
    let morphologyArray, rhythmArray, type
    if (input?.algorithm === "HighSpecificity") {
        morphologyArray = input.morphologyHighSpec
        rhythmArray = input.rhythmHighSpec
        type = "Asymptomatic"
    } else {
        // Assume HighSensitivity if not HighSpecificity
        morphologyArray = input.morphologyHighSens
        rhythmArray = input.rhythmHighSens
        type = "Symptomatic"
    }

    // Backward compatibility: handle string indices, number indices, and string labels
    let morphology = (morphologyArray || []).map((id) => {
        if (typeof id === "string" && !isNaN(id)) return MorphologyLabels[parseInt(id)]
        if (typeof id === "number") return MorphologyLabels[id]
        if (MorphologyLabels.includes(id)) return id
        return undefined
    }).filter(Boolean)
    let rhythm = (rhythmArray || []).map((id) => {
        if (typeof id === "string" && !isNaN(id)) return RhythmLabels[parseInt(id)]
        if (typeof id === "number") return RhythmLabels[id]
        if (RhythmLabels.includes(id)) return id
        return undefined
    }).filter(Boolean)

    return { morphology, rhythm, type, morphologyArray, rhythmArray }
}

export default main